import { gql } from '@apollo/client'

import { SHOP_CART_FRAGMENT } from '../fragments'

export const UPDATE_CART_ITEM = gql`
  mutation UpdateCartItem($id: ID!, $quantity: Int!) {
    updateCartItem(input: { id: $id, quantity: $quantity }) {
      cart {
        ...ShopCart
      }
    }
  }
  ${SHOP_CART_FRAGMENT}
`

export const DESTROY_CART_ITEM = gql`
  mutation DestroyCartItem($id: ID!) {
    destroyCartItem(input: { id: $id }) {
      cart {
        ...ShopCart
      }
    }
  }
  ${SHOP_CART_FRAGMENT}
`
